export default "__VITE_ASSET__4516dbea__"